<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from './stores/auth';
import { useRoute } from 'vue-router';
import AppShell from './components/AppShell.vue';
import AppToaster from './components/AppToaster.vue';
import AppConfirm from './components/AppConfirm.vue';

const auth = useAuthStore();
const route = useRoute();

onMounted(async () => {
  await auth.bootstrap();
});
</script>

<template>
  <AppShell v-if="route.meta.layout !== 'blank'" />
  <router-view v-else />
  <AppToaster />
  <AppConfirm />
</template>
